import React, { useEffect, useState } from "react";
import { listMySchools, createSchool } from "./happyschoolApi";
import { getActiveSchoolId, setActiveSchoolId } from "./activeSchool";

const HappySchoolSchools = () => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [creating, setCreating] = useState(false);
  const [activeId, setActiveId] = useState(getActiveSchoolId());

  const reload = () => {
    setLoading(true);
    listMySchools()
      .then(setSchools)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(reload, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setCreating(true);
    setError("");
    try {
      const school = await createSchool(name.trim());
      setName("");
      reload();
      setActiveId(school.id);
      setActiveSchoolId(school.id);
    } catch (err) {
      setError(err.message);
    } finally {
      setCreating(false);
    }
  };

  const choose = (id) => {
    setActiveId(id);
    setActiveSchoolId(id);
  };

  return (
    <div style={{ padding: 24, maxWidth: 700, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 16px 0" }}>Trường của tôi</h2>

      <form onSubmit={handleCreate} style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Tên trường mới"
          style={{ flex: 1, padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
        />
        <button type="submit" disabled={creating} style={btnStyle}>
          {creating ? "Đang tạo..." : "Tạo trường"}
        </button>
      </form>

      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {loading ? (
        <p>Đang tải...</p>
      ) : schools.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Chưa có trường nào.</p>
      ) : (
        <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 8 }}>
          {schools.map((s) => (
            <li
              key={s.id}
              onClick={() => choose(s.id)}
              style={{
                padding: 12,
                border: s.id === activeId ? "2px solid #0ea5a3" : "1px solid #e5e7eb",
                borderRadius: 8,
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>
                <strong>{s.name}</strong> <span style={{ color: "#6b7280" }}>({s.role})</span>
              </span>
              {s.id === activeId && <span style={{ color: "#0ea5a3" }}>Đang chọn</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const btnStyle = {
  padding: "8px 16px",
  background: "#0ea5a3",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
  fontWeight: 600,
};

export default HappySchoolSchools;
